import '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const _excluded = ["children", "onButtonSelected", "onClick", "active", "value"];
const ToggleButton = _ref => {
  let {
      children,
      onButtonSelected,
      onClick,
      active,
      value
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const handleChange = event => {
    if (onClick) {
      onClick(event.target.value);
      if (event.isDefaultPrevented()) {
        return;
      }
    }
    if (onButtonSelected) {
      onButtonSelected(event, value);
    }
  };
  const defaultProps = _objectSpread2({
    variant: 'tertiary'
  }, rest);
  return /*#__PURE__*/createElement(Button, _extends({
    onClick: handleChange,
    onChange: handleChange,
    active: active
  }, defaultProps), children);
};

export default ToggleButton;
